import { FC, useCallback, useContext } from "react";
import leftFrontFoot from "../../../assets/PainPointGeneral.png";
import leftSideFoot from "../../../assets/Foot-Image-7.png";

import "./style.scss";
import { useAnalysisFlow } from "../../../contexts";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";

const LeftPainPoint: FC = () => {
	const { footcareAnalysis, setFootcareAnalysis, setCurrentIdx, handleNextClick, handlePrevClick } =
		useAnalysisFlow();
	const handlePainPointChange = (paintPoint: number) => {
		console.log(paintPoint);
		setFootcareAnalysis((prev: any) => {
			const updatedList = prev.left_pain_points_list.includes(paintPoint)
				? prev.left_pain_points_list.filter((point: number) => point !== paintPoint)
				: [...prev.left_pain_points_list, paintPoint];
			return {
				...prev,
				left_pain_points_list: updatedList
			};
		});
	};
	return (
		<div className="left-pain-point h-full w-full relative flex flex-col items-center">
			<div className="sub-header text-center bg-secondary text-white">
				Do You have any pain on Left foot? Please select.
			</div>
			<div className="flex flex-row h-fit mt-16 max-h-[800px] w-full">
				<div className="h-full w-1/2 relative image-container">
					<img src={leftFrontFoot} alt="Responsive Example" className="responsive-image"></img>

					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(1)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-1"
						}
						onClick={() => handlePainPointChange(1)}
					>
						1
					</div>
					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(2)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-2"
						}
						onClick={() => handlePainPointChange(2)}
					>
						2
					</div>
					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(3)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-3"
						}
						onClick={() => handlePainPointChange(3)}
					>
						3
					</div>
				</div>
				<div className="h-full w-2/5 relative image-container">
					<img src={leftSideFoot} alt="Responsive Example" className="responsive-image"></img>

					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(4)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-4"
						}
						onClick={() => handlePainPointChange(4)}
					>
						4
					</div>
					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(7)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-7"
						}
						onClick={() => handlePainPointChange(7)}
					>
						7
					</div>
					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(5)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-5"
						}
						onClick={() => handlePainPointChange(5)}
					>
						5
					</div>
					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(6)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-6"
						}
						onClick={() => handlePainPointChange(6)}
					>
						6
					</div>
					<div
						className={
							(footcareAnalysis.left_pain_points_list.includes(8)
								? "pain-point-item-selected"
								: "pain-point-item") + " left-pain-point-8"
						}
						onClick={() => handlePainPointChange(8)}
					>
						8
					</div>
				</div>
			</div>
			<div className="bottom-pointer-left" onClick={handlePrevClick}>
				<MdKeyboardDoubleArrowLeft className="hover:scale-90 text-3xl" />
				<span className="text-[1.5vw] font-bold ml-3">Back</span>
			</div>
			<div className="bottom-pointer-right" onClick={handleNextClick}>
				<span className="text-[1.5vw] font-bold">Next</span>
				<MdKeyboardDoubleArrowRight className="hover:scale-90 text-3xl ml-3" />
			</div>
		</div>
	);
};

export default LeftPainPoint;
